// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__zHobv","header":"Messages_header__yQYEi"};